import { render, staticRenderFns } from "./CoursePlay.vue?vue&type=template&id=c1a4c8ba&scoped=true&"
import script from "./CoursePlay.vue?vue&type=script&lang=js&"
export * from "./CoursePlay.vue?vue&type=script&lang=js&"
import style0 from "./CoursePlay.vue?vue&type=style&index=0&id=c1a4c8ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a4c8ba",
  null
  
)

export default component.exports